import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "./index.css"
import App from "./app.tsx"
import { BrowserRouter } from "react-router"

import "@fontsource/inter/latin-300.css"
import "@fontsource/inter/latin-400.css"
import "@fontsource/inter/latin-500.css"
import "@fontsource/inter/latin-600.css"
import "@fontsource/poppins/latin-600.css"
import "@fontsource/roboto/latin-500.css"
import { Toaster } from "@/components/ui/sonner.tsx"

import { PostHogProvider } from "posthog-js/react"
import { posthog } from "@/lib/posthog.ts"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <BrowserRouter>
        <App />
        <Toaster closeButton richColors position="top-center" />
      </BrowserRouter>
    </PostHogProvider>
  </StrictMode>
)
